export default function detectNetwork(callback, eventSink) {
    const [subscribe] = eventSink;
    return subscribe({ verb: 'update', namespace: 'application', relation: 'network' }, ({ isOnline }) => {
        callback({ online: isOnline });
    });
}
